import {cs} from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {Invoke} from "@Common/react/invoke";
import {Static2} from "@Common/react/static-2";
import {OnUnmounted} from "@Common/react/on-unmounted";

export const StyleTag = ({next}) => cs(
    ["cleanup", (_, next) => Static2({next})],
    ({cleanup}) => next({
        render: ({content}) => fragments(
            Invoke({
                action: () => {
                    const style = document.createElement("style");
                    style.innerHTML = content;
                    document.head.appendChild(style);

                    cleanup.set(() => {
                        style.remove();
                    });
                },
            }),
            OnUnmounted({
                action: () => {
                    const cleanup1 = cleanup.get();
                    if (cleanup1) {
                        cleanup1();
                        cleanup.set(null);
                    }
                },
            })
        ),
    })
);